<script setup>

import BarreMenu from './barreMenu/BarreMenu.vue';
import PanelRapport from './panelRapport/PanelRapport.vue'

const { modele } = defineProps({
	modele: Object
})

</script>

<template>
	<div class="panel-centre">
		<BarreMenu :modele="modele"/>
		<PanelRapport :rapport="modele?.rapport"/>
	</div>
</template>

<style scoped>

.panel-centre {
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
	border-left: solid 2px var(--couleur-bordure);
	border-right: solid 2px var(--couleur-bordure);
	border-bottom: solid 2px var(--couleur-bordure);
}

</style>